import React, { createContext, useContext, useState, useCallback } from 'react';
import QuoteModal from '../components/QuoteModal';

const QuoteModalContext = createContext(null);

export const QuoteModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openQuoteModal = useCallback(() => setIsOpen(true), []);
  const closeQuoteModal = useCallback(() => setIsOpen(false), []);

  return (
    <QuoteModalContext.Provider value={{ openQuoteModal, closeQuoteModal, isOpen }}>
      {children}
      <QuoteModal isOpen={isOpen} onClose={closeQuoteModal} />
    </QuoteModalContext.Provider>
  );
};

export const useQuoteModal = () => {
  const ctx = useContext(QuoteModalContext);
  if (!ctx) {
    throw new Error('useQuoteModal must be used within QuoteModalProvider');
  }
  return ctx;
};
